<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('mailings') }} -> {{ $t('list-mailing') }}
    </h1>
    <div class="main__body">
      <div class="form-row">
        <div class="form-group">
          <label>{{ $t('search') }} {{ $t('message').toLowerCase() }}</label>
          <input class="large" type="text" :placeholder="$t('name-mailing')" v-model="search.text" v-on:keyup.enter="getMailing()">
        </div>
      </div>
      <table class="table table-striped table-mailing">
        <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">{{ $t('name-mailing') }}</th>
          <th scope="col">{{ $t('text') }}</th>
          <th :class="{active: isActiveDate}" class="order pointer" scope="col" @click="sortDate()">{{ $t('date') }} {{ $t('and') }} {{ $t('time').toLowerCase() }} {{ $t('sending').toLowerCase() }}</th>
          <th scope="col">{{ $t('segment') }}</th>
          <th scope="col">{{ $t('status') }}</th>
          <th scope="col">{{ $t('messenger') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in mailing" v-bind:key="item.mid">
          <th scope="row">
            {{ index + 1}}
          </th>
          <td>{{ item.mName }}</td>
          <td class="mailing-message">{{ item.message }}</td>
          <td>{{ item.date_send }}</td>
          <td>{{ item.segment_name }}</td>
          <td class="text-danger" v-if="item.send == 0">{{ $t('not') }} {{ $t('shipped') }}</td>
          <td class="text-success" v-else>{{ $t('shipped') }}</td>
          <td v-if="item.type == 1">
            <img src="@/assets/social/telegram.svg">
            <div class="rightside-action">
              <a @click="deleteAccept(item.mid, item.mName)">
                <img src="@/assets/icon/trash.svg">
              </a>
              <a @click="editMailing(item.mid)" v-if="item.send == 0">
                <img src="@/assets/icon/edit.svg">
              </a>
              <a @click="refreshMailing(item.mid)">
                <img src="@/assets/icon/refresh.svg">
              </a>
            </div>
          </td>
          <td v-else-if="item.type == 2">
            <img src="@/assets/social/viber.svg">
            <div class="rightside-action">
              <a @click="deleteAccept(item.mid, item.mName)">
                <img src="@/assets/icon/trash.svg">
              </a>
              <a @click="editMailing(item.mid)" v-if="item.send == 0">
                <img src="@/assets/icon/edit.svg">
              </a>
              <a @click="refreshMailing(item.mid)">
                <img src="@/assets/icon/refresh.svg">
              </a>
            </div>
          </td>
          <td v-else-if="item.type == 3">
            <img src="@/assets/social/sms.svg">
            <div class="rightside-action">
              <a @click="deleteAccept(item.mid, item.mName)">
                <img src="@/assets/icon/trash.svg">
              </a>
              <a @click="editMailing(item.mid)" v-if="item.send == 0">
                <img src="@/assets/icon/edit.svg">
              </a>
              <a @click="refreshMailing(item.mid)">
                <img src="@/assets/icon/refresh.svg">
              </a>
            </div>
          </td>
          <td v-else-if="item.type == 4">
            <img src="@/assets/social/email.svg">
            <div class="rightside-action">
              <a @click="deleteAccept(item.mid, item.mName)">
                <img src="@/assets/icon/trash.svg">
              </a>
              <a @click="editMailing(item.mid)" v-if="item.send == 0">
                <img src="@/assets/icon/edit.svg">
              </a>
              <a @click="refreshMailing(item.mid)">
                <img src="@/assets/icon/refresh.svg">
              </a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
    <question-delete-mailing :mailing="this.deleteMailing" v-show="isModalDeleteMailingVisible"
                          @close="closeModalDeleteMailingVisible"/>
  </div>
</template>

<style scoped>
.table-mailing tbody tr{
  height: 160px;
}
.mailing-message{
  max-width: 322px;
}
</style>

<script>
import axios from "axios";
import loading from "vue-loading-overlay";
import questionDeleteMailing from "../components/modal/questionDeleteMailing";

export default {
  name: 'create-segment',
  data: function () {
    return {
      mailing: [],
      segments: [],
      isActiveDate: true,
      search: {
        text: '',
        date: 'DESC',
      },
      deleteMailing: {
        id: 0,
        name: '',
      },
      isLoading: false,
      fullPage: true,
      isModalDeleteMailingVisible: false,
    }
  },
  created: function () {
    this.getMailing();
    this.getSegments();
  },
  mounted() {
    this.$root.$on('updateMailing', () => {
      this.getMailing();
    });
  },
  methods: {
    sortDate: function(){
      if(this.isActiveDate){
        this.isActiveDate = false;
        this.search.date = 'ASC';
        this.getMailing();
      }else{
        this.isActiveDate = true;
        this.search.date = 'DESC';
        this.getMailing();
      }
    },
    getMailing: function () {
      this.isLoading = true;
      axios.post('getMailings', this.search).then(response => {
        var status = response.data.status;
        if (status) {
          this.mailing = response.data.mailings;
          this.isLoading = false;
        }
      });
    },
    sendMailing: function(){
      axios.post('sendMailing');
    },
    getSegments: function(){
      this.isLoading = true;
      axios.post('getSegments').then(response => {
        var status = response.data.status;
        if(status){
          this.segments = response.data.segments;
          this.isLoading = false;
        }
      });
    },
    deleteAccept: function(id, name){
      this.deleteMailing.id = id;
      this.deleteMailing.name = name;
      this.showModalDeleteMailingVisible();
    },
    editMailing: function(id){
      this.$router.push({
        path: `/edit-mailing/${id}`
      });
    },
    refreshMailing: function(id){
      console.log(id);
      this.$router.push({
        path: `/create-mailing/${id}`
      });
    },
    showModalDeleteMailingVisible() {
      this.isModalDeleteMailingVisible = true;
    },
    closeModalDeleteMailingVisible() {
      this.isModalDeleteMailingVisible = false;
    },
  },
  components: {
    loading, questionDeleteMailing
  }
}
</script>